import {
  DimensionValue,
  InsightsMetricSelectOption,
  MetricValue,
} from 'common/src/modules/analytics/analytics.types';

export default function toNameValueMapping(
  options: InsightsMetricSelectOption<DimensionValue | MetricValue>[],
) {
  return Object.fromEntries(options.map(({label, value}) => [label, value]));
}
